<form #blockInputs="ngForm">
  <glxy-form-field>
    <glxy-label>{{ 'EMAIL_BUILDER.HEADING_BLOCK.TITLE' | translate }}</glxy-label>
    <textarea
      #title
      #titleModel="ngModel"
      matInput
      cdkTextareaAutosize
      cdkAutosizeMinRows="1"
      cdkAutosizeMaxRows="5"
      [(ngModel)]="content.title"
      placeholder="{{ 'PLACEHOLDER_OPTIONAL' | translate }}"
      name="Title Text"
      autocomplete="off"
      sharedContainsValidDynamicContent
    ></textarea>
    <email-dynamic-component-selector glxySuffix [target]="title" [(model)]="content.title" />
    @if (titleModel.hasError('invalidDynamicComponent') && titleModel.touched) {
      <glxy-error>
        {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.DYNAMIC_CONTENT' | translate }}
      </glxy-error>
    }
  </glxy-form-field>

  <glxy-form-field>
    <glxy-label>{{ 'EMAIL_BUILDER.HEADING_BLOCK.SUBTITLE' | translate }}</glxy-label>
    <textarea
      #subtitle
      #subtitleModel="ngModel"
      matInput
      [(ngModel)]="content.subtitle"
      cdkTextareaAutosize
      cdkAutosizeMinRows="1"
      cdkAutosizeMaxRows="5"
      placeholder="{{ 'PLACEHOLDER_OPTIONAL' | translate }}"
      name="Subtitle Text"
      autocomplete="off"
      sharedContainsValidDynamicContent
    ></textarea>
    <email-dynamic-component-selector glxySuffix [target]="subtitle" [(model)]="content.subtitle" />
    @if (subtitleModel.hasError('invalidDynamicComponent') && subtitleModel.touched) {
      <glxy-error>
        {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.DYNAMIC_CONTENT' | translate }}
      </glxy-error>
    }
  </glxy-form-field>

  <glxy-form-field>
    <glxy-label>{{ 'EMAIL_BUILDER.HEADING_BLOCK.TEXT_ALIGN' | translate }}</glxy-label>
    <mat-button-toggle-group
      name="fontStyle"
      aria-label="Font Style"
      [(ngModel)]="content.textAlign"
      name="Title Text Align"
    >
      <mat-button-toggle value="left">
        <mat-icon inline="true">format_align_left</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle value="center">
        <mat-icon inline="true">format_align_center</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle value="right">
        <mat-icon inline="true">format_align_right</mat-icon>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </glxy-form-field>
</form>
